import { useAppSelector } from 'app/hooks';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';
import { selectPlantAnalytics } from 'features/Analysis/analysisSlice';
import { useEffect, useRef, useState } from 'react';
import style from '../../pages/Analysis/Analysis.module.scss';
function AnalysisDetailChart(props) {
  const chartRef = useRef(null);
  const [chartInstance, setChartInstance] = useState(null);
  const plantAnalytics = useAppSelector(selectPlantAnalytics);

  const listColor = [
    '#E11D48',
    '#0284C7',
    '#059669',
    '#FB7185',
    '#A21CAF',
    '#4338CA',
    '#60A5FA',
    '#164E63',
    '#2DD4BF',
    '#365314',
    '#CA8A04',
    '#FACC15',
    '#EA580C',
    '#F97316',
    '#7F1D1D',
    '#44403C',
    '#A3A3A3',
    '#0F172A',
    '#64748B',
    '#FB923C',
  ];
  useEffect(() => {
    if (chartRef && chartRef.current && chartInstance == null) {
      const newChartInstance = new Chart(chartRef.current, chartConfig);
      setChartInstance(newChartInstance);
    }
  }, []);

  useEffect(() => {
    if (chartInstance) {
      updateDataset(plantAnalytics);
    }
  }, [plantAnalytics]);

  const installDataset = (listOne) => {
    let newList = [];
    for (let i = 0; i < listOne.length; i++) {
      let newItem = {
        type: 'bar',
        label: listOne[i].label,
        data: listOne[i].dataChart,
        unit: 'kWh/kw',
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        borderColor: listColor[i],
        borderWidth: 1,
        backgroundColor: listColor[i],
      };
      newList = [...newList, newItem];
    }
    return newList;
  };

  const updateDataset = (listOne) => {
    chartInstance.data.labels = [];
    chartInstance.data.datasets = installDataset(listOne);
    chartInstance.update();
  };

  const data = {
    datasets: [
      {
        type: 'bar',
        label: [],
        data: [],
        unit: 'kWh',
        parsing: {
          yAxisKey: 'value',
          xAxisKey: 'ts',
        },
        borderColor: listColor[0],
        borderWidth: 1,
        backgroundColor: listColor[0],
      },
    ],
  };

  const chartConfig = {
    data: data,
    options: {
      maintainAspectRatio: false,
      elements: {
        point: {
          radius: 3,
        },
        line: {
          tension: 0.3,
        },
      },
      interaction: {
        mode: 'nearest',
        axis: 'x',
        intersect: false,
      },
      plugins: {
        annotation: {
          annotations: {},
        },
        title: {
          text: 'Chart.js Time Scale',
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              var label = context.dataset.label || '';
              var unit = context.dataset.unit;
              if (label) {
                label += ': ';
              }
              if (context.parsed.y !== null) {
                label += `${context.parsed.y} ${unit}`;
              }
              return label;
            },
          },
        },
      },
      scales: {
        x: {
          type: 'time',
          title: {
            display: false,
            text: 'Time',
            color: '#191',
            font: {
              family: 'Times',
              size: 20,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          time: {
            unit: 'month',
          },
        },
        y: {
          type: 'linear',
          display: true,
          position: 'left',
          title: {
            display: false,
            text: 'Productivity efficiency(kWh/kw)',
            color: '#038cfc',
            font: {
              family: 'Times',
              size: 15,
              style: 'normal',
              lineHeight: 1.2,
            },
          },
          ticks: {
            // Include a dollar sign in the ticks
            callback: function (value, index, values) {
              return `${value} kWh/kw`;
            },
          },
        },
      },
    },
  };

  return (
    <>
      <div className={style.chart_detail}>
        <canvas ref={chartRef} />
      </div>
    </>
  );
}

export default AnalysisDetailChart;
